import { Helmet } from 'react-helmet-async';
import ComunidadesV2 from 'src/sections/@dashboard/ComunidadesV2/ComunidadesV2';

export default function ComunidadesV2Page() {
  return (
    <>
      <Helmet>
        <title>Comunidades - Eyhe</title>
      </Helmet>

      <ComunidadesV2 />
    </>
  );
}
